import script from "./ProductManagement.vue?vue&type=script&setup=true&lang=js"
export * from "./ProductManagement.vue?vue&type=script&setup=true&lang=js"

import "./ProductManagement.vue?vue&type=style&index=0&id=5e94d318&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5e94d318"]])

export default __exports__